import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistPartial } from 'redux-persist/es/persistReducer';

interface SelectedProfile {
  InvestorId?: string | number;
  AccountStatus?: string;
  UserType?: string;
  ProfileName?: string;
  [key: string]: any
}

interface SelectedProfileState {
  [auctionId: string]: SelectedProfile;
}

const initialState: SelectedProfileState = {};

const selectedProfileSlice = createSlice({
  name: 'selectedProfile',
  initialState,
  reducers: {
    setSelectedProfileForAuction: (
      state,
      action: PayloadAction<{
        auctionId: string;
        profile: SelectedProfile;
      }>
    ) => {
      const { auctionId, profile } = action.payload;
      state[auctionId] = profile;
    },
    clearSelectedProfile: (state, action: PayloadAction<string>) => {
      const auctionId = action.payload;
      delete state[auctionId];
    },
  },
});

export const { setSelectedProfileForAuction, clearSelectedProfile } = selectedProfileSlice.actions;
export default selectedProfileSlice.reducer;
